export const CHECKBOX_COLUMN_KEY = '__checkbox__virtual';